/* eslint-disable react-hooks/set-state-in-effect -- ignore*/
import { cx } from 'cva';
import { type FunctionComponent, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useTimeout } from 'react-use';
import {
  DATA_LOADING_TIMEOUT,
  DATA_LOADING_TIMEOUT_ERROR_MESSAGE,
} from '../../constants';
import { useTranslation } from '../../i18n/resources';
import { Footer } from '../Layout/Footer/Footer';
import { LoadingScreen } from '../LoadingScreen/LoadingScreen';
import { Menu } from '../Menu/Menu';
import { ProblemMessage } from '../ProblemMessage/ProblemMessage';
import styles from './Splash.module.css';

export type SplashProps = {
  timeoutMs?: number;
};

export const Splash: FunctionComponent<SplashProps> = ({
  timeoutMs = DATA_LOADING_TIMEOUT,
}) => {
  const [isReady] = useTimeout(timeoutMs);
  const { t } = useTranslation();
  const [showLoading, setShowLoading] = useState(false);

  // UNTESTABLE: Inlined logic.
  const timedOut = !!isReady();

  useEffect(() => {
    setShowLoading(true);
  }, []);

  const loadingDivRef = useRef<HTMLDivElement>(null);
  const errorDivRef = useRef<HTMLDivElement>(null);

  return (
    <div className={cx(styles.root, timedOut && styles.problem)}>
      <CSSTransition
        classNames={{
          enter: styles.fadeEnter,
          enterActive: styles.fadeEnterActive,
          exit: styles.fadeExit,
          exitActive: styles.fadeExitActive,
        }}
        in={showLoading}
        nodeRef={loadingDivRef}
        timeout={1000}
      >
        <div ref={loadingDivRef}>
          <Menu failSafe />

          <CSSTransition
            classNames={{
              enter: styles.fadeEnter,
              enterActive: styles.fadeEnterActive,
              exit: styles.fadeExit,
              exitActive: styles.fadeExitActive,
            }}
            in={timedOut}
            nodeRef={errorDivRef}
            timeout={1000}
            unmountOnExit
          >
            <div ref={errorDivRef}>
              <ProblemMessage
                logMessage={`Splash - ${DATA_LOADING_TIMEOUT_ERROR_MESSAGE}`}
              />
              <Footer />
            </div>
          </CSSTransition>
          {!timedOut && (
            <div className={styles.loading}>
              <LoadingScreen
                description={t('loading', 'message')}
                showBibleVerse
                showLogo
              />
            </div>
          )}
        </div>
      </CSSTransition>
    </div>
  );
};
